module.exports = __webpack_public_path__ + "img/11.13452b89.png";